// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__NDxAs","errorLogs":"styles_errorLogs__3zeee"};